:host svg{fill:#232426;opacity:.38}:host.delivery:not(.paused) svg{fill:#1db55a;opacity:1}:host.training:not(.paused) svg{fill:#52baff;opacity:1}:host.certification:not(.paused) svg{fill:#52baff;opacity:1}
/*# sourceMappingURL=navbar-project-status-indicator.component.css.map */
